import { configureStore } from "@reduxjs/toolkit";
import DepartmentList from "./slice/super-admin/master/department/DepartmentList";
import DoctorList from "./slice/admin/doctor/DoctorList";
import PatientList from "./slice/admin/patient/PatientList";
import AdminDepartmentList from "./slice/admin/master/department/AdminDepartmentList";
import AdminDesignationList from "./slice/admin/master/designation/AdminDesignationList";
import DesignationList from "./slice/super-admin/master/designation/DesignationList";
import PathologyList from "./slice/super-admin/pathology/PathologyList";
import CityList from "./slice/super-admin/city/CityList";
import AdminDashboard from "./slice/admin/dashboard/AdminDashboard";
import DocterDetails from "./slice/admin/doctor/DocterDetails";
import PatientDetails from "./slice/admin/patient/PatientDetails";
import ModuleList from "./slice/super-admin/module/ModuleList";
import TestList from './slice/admin/text-report/TestList'

const Store = configureStore({
    reducer: {
        CityList: CityList,
        DepartmentList: DepartmentList,
        DesignationList: DesignationList,
        PathologyList: PathologyList,
        ModuleList : ModuleList,

        // ADMIN STORE
        AdminDashboard:AdminDashboard,
        AdminDepartmentList: AdminDepartmentList,
        AdminDesignationList: AdminDesignationList,
        DoctorList: DoctorList,
        DocterDetails:DocterDetails,
        PatientList: PatientList,
        PatientDetails:PatientDetails,
        TestList : TestList
    }
})
export default Store;